import { Button } from '@planuze/ui';
import { useStaffContent } from '../../content/sections/staff.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

interface Props {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onSuspend: () => void;
  readonly onReactivate: () => void;
  readonly onClear: () => void;
}

export function StaffBulkBar({ selectedCount, busy, onSuspend, onReactivate, onClear }: Props) {
  const copy = useStaffContent().bulk;
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.selected(selectedCount)}
      clearLabel={copy.clear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onSuspend}>
        {copy.suspend}
      </Button>
      <Button size="sm" disabled={busy} onClick={onReactivate}>
        {copy.reactivate}
      </Button>
    </BulkSelectionBar>
  );
}
